module.exports = __webpack_public_path__ + "img/location-category-store.ea692ce.png";